export default "__VITE_ASSET__CZbLanp8__"